// ------
// Check and update warning if gift or ticket
// ------
const checkAndUpdateWarning = () => {
  const orderItem = document.querySelectorAll('.order-summary__body-inner');
  let includeGifts = false;
  let includeTickets = false;
  orderItem.forEach((el) => {
    if (el.style.display !== 'none') {
      if (el.getAttribute('data-key').includes('gift_')) {
        includeGifts = true;
      } else {
        includeTickets = true;
      }
    }
  });
  const onlyTickets = document.querySelector('#only_tickets');
  const onlyGifts = document.querySelector('#only_gifts');
  const both = document.querySelector('#both');
  if (onlyTickets && onlyGifts && both) {
    onlyTickets.closest('.info-text').style.display = 'none';
    onlyGifts.closest('.info-text').style.display = 'none';
    both.closest('.info-text').style.display = 'none';
    if (includeGifts && !includeTickets) {
      onlyGifts.closest('.info-text').style.display = '';
    } else if (!includeGifts && includeTickets) {
      onlyTickets.closest('.info-text').style.display = '';
    } else {
      both.closest('.info-text').style.display = '';
    }
  }
};

// ********
// Counter
// ********
const setNewPriceForBlock = (element) => {
  let price = 0;
  const article = element.closest('article');
  if (article) {
    article.querySelectorAll('.counter-block').forEach((item) => {
      price +=
        parseFloat(item.querySelector('.counter-block__text--price').innerHTML) *
        item.querySelector('.counter__input').value;
    });
    article.querySelector('.mod-card__total-price').innerHTML = euro.format(price);
  }
};
const setNewFormPrice = async (element) => {
  const summary = element.closest('.payment-summary__popup, .checkout-module__right');
  const article = element.closest('.counter-block');
  const price = parseFloat(
    article.querySelector('.counter__input').value * article.querySelector('.counter-price').value,
  );
  article.querySelector('.counter-block__text--price').innerHTML = euro.format(price);
  let priceAll = 0;
  let priceAllVat = 0;
  summary.querySelectorAll('.counter-block__text--price.text--base').forEach((item) => {
    if (!item.closest('.item-to-delete')) {
      const orderSummaryBodyInner = item.closest('.order-summary__body-inner');
      const isGift = orderSummaryBodyInner.dataset.key.includes('gift_');
      const vatRate = isGift ? localData.vat.gift : localData.vat.cart;
      priceAll += roundToTwo(parseFloat(item.innerHTML));
      priceAllVat += (roundToTwo(parseFloat(item.innerHTML)) / 100) * Number(vatRate);
    }
  });
  const [date, type] = article.closest('.order-summary__body-inner').dataset.key.split('_');
  const data = { date, type };
  article
    .closest('.order-summary__body-inner')
    .querySelectorAll('input')
    .forEach((it) => {
      if (it.value) {
        data[it.name] = it.value;
      }
    });
  await setItemToCookie(data);

  const orderSummaryBody = article.closest('.order-summary__body-inner');
  const summaryInputs = [...orderSummaryBody.querySelectorAll('input[type=text]')];
  const quantity = summaryInputs.reduce((acc, input) => acc + Number(input.value), 0);
  if (!quantity) {
    orderSummaryBody.style.display = 'none';
  }

  const cartButtonBadge = document.querySelector('.btn--cart-button .btn__badge');
  const allInputs = [...summary.querySelectorAll('input[type=text]')];
  const quantityAll = allInputs.reduce((acc, input) => acc + Number(input.value), 0);
  if (cartButtonBadge && quantityAll) {
    cartButtonBadge.innerHTML = quantityAll;
  }

  const priceText = euro.format(priceAll);
  document.querySelector('.order-summary__price.text-right').innerHTML = euro.format(priceAll - priceAllVat);
  document.querySelector('.vat-price.text-right').innerHTML = euro.format(priceAllVat);
  document.querySelector('.order-summary__price-row .text--2xl').innerHTML = priceText;
  if (document.querySelector('#payment-summary-price')) {
    document.querySelector('#payment-summary-price').innerHTML = priceText;
  }
  checkAndUpdateWarning();
  if (document.querySelector('.sc-checkout-module') || !quantityAll) {
    // WsPay to get new secret token for checkout form
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
};

const addRemoveCounterButton = (element, toggle, operation) => {
  const parentElem = element.closest('.counter');
  const inputElem = parentElem.querySelector('.counter__input');
  const minusButton = parentElem.querySelector('.counter__button--remove');
  let currentVal = parseInt(inputElem.value, 10);
  // eslint-disable-next-line no-param-reassign
  if (currentVal >= 0) {
    // eslint-disable-next-line
    inputElem.value = toggle ? ++currentVal : --currentVal;
    minusButton.classList.remove('is-disabled');
  }
  if (currentVal === 0) {
    minusButton.classList.add('is-disabled');
  }
  if (element.closest('.payment-summary__popup, .checkout-module__right')) {
    // footer popup cart add/remove functionality
    setAddRemove(element, operation);
    setNewFormPrice(element);
  } else {
    // other add/remove buttons
    setNewPriceForBlock(element);
  }
};

attachEvent('.counter__button--add', 'click', (ev) => {
  // addPerson(ev.target);
  addRemoveCounterButton(ev.target, true, 'add');
  checkAndUpdateWarning();
});

attachEvent('.counter__button--remove', 'click', (ev) => {
  // removePerson(ev.target);
  addRemoveCounterButton(ev.target, false, 'remove');
  checkAndUpdateWarning();
});

// ********
// Counter Disabled Class
// ********
const initCounters = () => {
  const counterEle = document.querySelectorAll('.counter');
  counterEle.forEach((el) => {
    const inputElem = el.querySelector('.counter__input');
    const minusButton = el.querySelector('.counter__button--remove');
    const currentVal = parseInt(inputElem.value, 10);

    if (currentVal > 0) {
      minusButton.classList.remove('is-disabled');
    }
  });
};
// ------
// Trash icon
// ------
attachEvent('button.order-summary__delete', 'click', (ev) => {
  ev.preventDefault();
  const item = ev.target.closest('.order-summary__body-inner');
  if (item) {
    removeAllEvent(item);
    item.classList.add('item-to-delete');
    item.querySelectorAll('input').forEach((i) => {
      // eslint-disable-next-line no-param-reassign
      i.value = 0;
    });
    item.style.display = 'none';
    setNewFormPrice(item.querySelector('.counter__button--add'));
  }
});

initCounters();
